<script>
	import { Col, Row, Container } from 'sveltestrap';
</script>

<section class="section common-section" id="features">
	<Container>
		<Row class="align-items-center">
			<Col lg={5} class="order-2 order-lg-1">
				<div class="features-box mt-5 mt-lg-0">
					<h3>A digital Software engineer studio creating modern & engaging online</h3>
					<p class="text-muted web-desc">
						As the Programer and Designer ,  we are the subject matter expert on the Coding and will work in collaboration with our Design & Training and Community Success & Partnerships teams to deliver on your  Program goals. 
					</p>
					<ul class="text-muted list-unstyled mt-4 features-item-list">
						<li class="">We put a lot of effort in design.</li>
						<li class="">The most important ingredient of successful software.</li>
						<li class="">contact our Orgnization.</li>
					</ul>
                <a href={"#"} class="btn btn-primary mt-4 waves-effect waves-light"
						>Learn More <i class="mdi mdi-arrow-right" /></a
					>
				</div>
			</Col>
			<Col lg={7} class="order-1 order-lg-2">
				<div class="features-img mx-auto me-lg-0">
                    <img src="images/growth-analytics.svg" alt="macbook_image" class="img-fluid" />
				</div>
			</Col>
		</Row>
	</Container>
</section>